import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import LoaderMain from 'components/shared/LoaderMain';
import { useLocation } from 'react-router-dom';

const PackagesResultSkeleton: FC = () => {
  const { pathname } = useLocation();
  return (
  <>
      <div className="packages-result-wr results-wr">
        <div className="flight-filter-wr default-shadow">
          <div className="flight-filter">
            <CheckboxSection />
            <CheckboxSection />
            <SliderSection />
            <CheckboxSection />
            <CheckboxSection />
            <CheckboxSection />
          </div>
        </div>
        <div className="package-list results-list">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="package-item default-shadow">
              <div className="package-item-img">
                <Skeleton height={228} width={300} />
              </div>
              <div className="package-item-data">
                <div>
                  <span className="name">
                    <Skeleton height={22.5} width={300} />
                  </span>
                  <div>
                    <Skeleton height={15} width={100} />
                  </div>
                </div>
                <span className="item">
                  <Skeleton height={19} width={280} />
                </span>
                <span className="item">
                  <Skeleton height={19} width={290} />
                </span>
                <span className="item">
                  <Skeleton height={19} width={150} />
                </span>
                <span className="item">
                  <Skeleton height={19} width={180} />
                </span>
                <span className="item">
                  <Skeleton height={19} width={120} />
                </span>
              </div>
              <div className="package-item-total">
                <div className="price-per-person">
                  <Skeleton height={16} width={120} />
                  <span className="price">
                    <Skeleton height={26.2} width={60} />
                  </span>
                </div>
                <div className="total-price">
                  <Skeleton height={18} width={130} />
                  <span className="price">
                    <Skeleton height={31} width={70} />
                  </span>
                </div>

                <Skeleton height={36} width={'100%'} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <LoaderMain systemProducts={pathname.includes('tour') ? 'Tours' : 'Nofshon'} />
  </>
  );
};

export default PackagesResultSkeleton;

export const CheckboxSection = () => {
  return (
    <section className="flight-filter-section">
      <div className="text-bold mb-15">
        <Skeleton width={100} />
      </div>

      <Skeleton width={120} style={{ marginBottom: 10 }} />
      <Skeleton width={180} style={{ marginBottom: 10 }} />
    </section>
  );
};

export const SliderSection = () => {
  return (
    <section className="flight-filter-section">
      <div className="text-bold mb-15">
        <Skeleton width={100} />
      </div>

      <div className="flight-filter-time">
        <span>
          {' '}
          <Skeleton width={100} />
        </span>
        <span>
          {' '}
          <Skeleton width={90} />
        </span>
      </div>
      <Skeleton width={'100%'} />
    </section>
  );
};
